var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"400px","padding":"24px 0"}},[_c('KLinearLoader',{attrs:{"type":"determinate","progress":75}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }